import { AxiosResponse } from "axios";
import { BASE_URL, httpClient } from "../config/develop-config";
import { payloadTeam } from "../entities/TeamEntity";

const getAllZone = async () => {
  const url = `${BASE_URL}/auth/zone`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};
const getAllZoneByCompany = async (company?: string) => {
  const url = `${BASE_URL}/auth/zone/${company}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};
const getAllZoneByTeam = async (teamId?: string) => {
  const url = `${BASE_URL}/auth/team/find-team-with-zone/${teamId}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data.responseData);
};
const postZone = async (payload: {
  company: string;
  zoneName: string;
  isActive: boolean;
  createBy: string;
}) => {
  return await httpClient
    .post(`${BASE_URL}/auth/zone`, payload)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const patchZone = async (payload: {
  zoneId: string;
  company: string;
  zoneName: string;
  isActive: boolean;
  updateBy: string;
}) => {
  return await httpClient
    .patch(`${BASE_URL}/auth/zone`, payload)
    .then((res: AxiosResponse) => res.data)
    .catch((err) => console.log(err));
};
const getAllTeam = async (payload: payloadTeam) => {
  const url = `${BASE_URL}/auth/team/find-team`;
  return await httpClient.get(url, { params: payload }).then((res: AxiosResponse) => res.data);
};
const getCheckZone = async (zoneId?: number) => {
  const url = `${BASE_URL}/auth/zone/zone-used-by-id/${zoneId}`;
  return await httpClient.get(url).then((res: AxiosResponse) => res.data);
};
export const zoneDatasource = {
  getAllZone,
  getAllZoneByCompany,
  postZone,
  patchZone,
  getAllTeam,
  getCheckZone,
  getAllZoneByTeam,
};
